module.exports = __webpack_public_path__ + "static/img/5.3b1ba58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v15_new_features/5.png
// module id = MDTq
// module chunks = 0